import { createBrowserRouter } from "react-router-dom";
import { CustomModal } from "../components/modals";
import { Settings } from "../components/views/account";
import { Account } from "../components/views/account/Account";
import { AllAccounts } from "../components/views/account/AllAccounts";
import { EditAccount } from "../components/views/account/EditAccount";
import { Legal } from "../components/views/account/Legal";
import { AddressForm, AddressSaved } from "../components/views/address";
import { AddNewAddressForm } from "../components/views/address/AddNewAddressForm";
import { EditAddressForm } from "../components/views/address/EditAddressForm";
import { SavingAddressScreen } from "../components/views/address/SavingAddressScreen";
import { HistoryOrders } from "../components/views/history";
// import { RequestPrevOrder } from "../components/views/history/RequestPrevOrder";
import { OrderInvoice } from "../components/views/invoice";
import { Login } from "../components/views/login";
import { SecurityCode } from "../components/views/login/SecurityCode";
import { MaintenanceView } from "../components/views/maintenance/MaintenanceView";
import { EvidenceOrder, InforOrder, OrderDone } from "../components/views/order-done";
import { OrderHistoryView } from "../components/views/orders/OrderHistoryView";
import { PickDate } from "../components/views/pick-date";
import { PreviewOrder } from "../components/views/preview-order";
import { ActiveOrders } from "../components/views/preview-order/ActiveOrders";
import { Dashboard, ProductQuantity } from "../components/views/product";
import { CilinderView } from "../components/views/product/CilinderView";
import { DashBoardContent } from "../components/views/product/DashBoardContent";
import { EstacionarioView } from "../components/views/product/EstacionarioView";
import { Quantity } from "../components/views/product/Quantity";
import { RegisterForm } from "../components/views/register-form/RegisterForm";
import { OrderSteps } from "../components/views/schedule-order/OrderSteps";
import { TrackOrder } from "../components/views/schedule-order/TrackOrder";
import { Questions } from "../components/views/support/Questions";
import { SupportPage } from "../components/views/support/SupportPage";
import { AppContext } from "../context";

export const router = createBrowserRouter([
   {
      path: '*',
      element: <MaintenanceView />
   },
   {
      path: '/',
      element: <Login />,
   },
   {
      path: '/register',
      element: <RegisterForm />,
   },
   {
      path: '/code',
      element: <SecurityCode />
   },
   {
      path: '/wop',
      element: <MaintenanceView />
   },
   {
      path: 'dashboard',
      element: <Dashboard />,
      children: [
         {
            path: 'content',
            element: <DashBoardContent />
         },
         // {
         //    path: 'settings',
         //    element: <Settings />,
         // },
         // {
         //    path: 'edit',
         //    element: <EditAccount />
         // },
         {
            path: 'accounts',
            element: <AllAccounts />,
         },
         {
            path: 'accounts/:id',
            element: <AddressSaved />,
         },
         {
            path: 'address-form',
            element: <AddressForm />
         },
         {
            path: ':id/nueva-direccion',
            element: <AddNewAddressForm />
         },
         {
            path: ':id/editar-direccion',
            element: <EditAddressForm />
         },
         {
            path: 'guardando',
            element: <SavingAddressScreen />
         },
         {
            path: 'date',
            element: <PickDate />,
         },
         {
            path: 'order',
            element: <OrderHistoryView />,
            // element: <ScheduleOrder />,
         },
         {
            path: 'track-order',
            // element: <OrderHistoryView />,
            element: <TrackOrder />,
         },
         {
            path: ':id/portatil',
            element: <CilinderView />
         },
         {
            path: ':id/estacionario',
            element: <EstacionarioView />
         },
         {
            path: 'history',
            element: <HistoryOrders />
         },
         // {
         //    path: 'informacion-pedido',
         //    element: <RequestPrevOrder />
         // },
         {
            path: 'preguntas-frecuentes',
            element: <Questions />
         },
         {
            path: 'order-gas',
            element: <OrderDone />
         },
         {
            path: 'preview',
            element: <PreviewOrder />
         },
         // {
         //    path: 'invoice-order',
         //    element: <OrderInvoice />
         // },
         // {
         //    path: 'evidence',
         //    element: <EvidenceOrder />
         // },
         // {
         //    path: 'soporte',
         //    element: <SupportPage />
         // },
         // {
         //    path: 'legal',
         //    element: <Legal />
         // },
         {
            path: 'active-orders',
            element: <ActiveOrders />
         },
      ]
   },
])